import { ProcedureInstanceBase, ProcedureInstanceBaseParams } from './procedureInstanceBase';

export class ProcedureInstance extends ProcedureInstanceBase {
  constructor(params: ProcedureInstanceBaseParams) {
    super(params);
  }
}
